import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region ../icons/dist/react/minimal/pip-exit.js
const PipExitIcon = (props, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	fill: "currentColor",
	"aria-hidden": "true",
	viewBox: "0 0 18 18",
	ref,
	...props,
	children: [
		/* @__PURE__ */ jsx("path", { d: "M13 2a4 4 0 0 1 4 4v2.646a3.5 3.5 0 0 0-1-.146h-.5V6A2.5 2.5 0 0 0 13 3.5H4A2.5 2.5 0 0 0 1.5 6v6A2.5 2.5 0 0 0 4 14.5h2.5v.5q.002.523.146 1H4a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4z" }),
		/* @__PURE__ */ jsx("rect", {
			width: 10,
			height: 7,
			x: 8,
			y: 10,
			rx: 2
		}),
		/* @__PURE__ */ jsx("path", { d: "M3.75 5a.75.75 0 0 0-.75.75v3.5a.75.75 0 0 0 1.5 0V6.5h2.75a.75.75 0 0 0 .743-.648L8 5.75A.75.75 0 0 0 7.25 5z" }),
		/* @__PURE__ */ jsx("path", { d: "M4.28 5.22a.75.75 0 0 0-1.06 1.06l3.5 3.5a.75.75 0 0 0 1.06-1.06z" })
	]
});
const ForwardRef = forwardRef(PipExitIcon);
//#endregion
export { ForwardRef as default };

//# sourceMappingURL=pip-exit.js.map